<div class="images-component-container">
  <ng-container *ngIf="mainImage$ | async as main" class="main-image-container">
    <cx-media
      [container]="main"
      class="main-image-media"
    > </cx-media>
  </ng-container>

  <ng-container *ngIf="thumbs$ | async as thumbs" class="carousel-container">
    <eb-carousel
      *ngIf="thumbs.length"
      class="thumbs"
      [items]="thumbs"
      itemWidth="54px"
      itemHeight="90px"
      [hideIndicators]="true"
      [template]="thumb"
      [previousIcon]="ICON_TYPE.CARET_UP"
      [nextIcon]="ICON_TYPE.CARET_DOWN"
    ></eb-carousel>
  </ng-container>

  <ng-template #thumb let-item="item">
    <cx-media
      [container]="item.container"
      tabindex="0"
      [alt]="(product$ | async)?.name"
      (focus)="openImage(item.container)"
      [class.is-active]="isActive(item.container) | async"
      format="product"
    >
    </cx-media>
  </ng-template>
</div>
